import { useState } from "react";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useCustomerValue } from "providers/CustomerContext";

import { ListLayout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { FormTitle, InboundSubmitButton } from "ui-components/Form";
import { EditableSelect, EditableText } from "ui-components/EditableInput2";

import { getTaskList, updateTaskList } from "services/data.outbound.service";
import { LoadingDialog } from "ui-components/Alert";
import BasicTabs from "ui-components/BasicTabs";
import { TableCard } from "ui-components/Layout";
import { getTaskListStatusCount } from "services/data.outbound.service";
import { useTeamValue } from "providers/TeamContext";

function TaskList() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const queryClient = useQueryClient();
  const [status, setStatus] = useState("NEW");
  const options = ["NEW", "HOLD", "CHANGE USER", "COMPLETED", "CANCEL"];
  const editPermission = allowAll || (Boolean(permissions["Task List"]) && permissions["Task List"].findIndex(b => b==="edit") !== -1);

  const [tabs, setTabs] = useState(
    options.map((x) => ({
      label: x,
      count: 0,
    }))
  );

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const { isFetching } = useQuery({
    queryKey: ["task-list", { customerCode, status }],
    queryFn: () => getTaskList({ customerCode, status }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => setData(data.data.data),
    onError,
  });
  useQuery({
    queryKey: ["task-list", status, { customerCode }],
    queryFn: () => getTaskListStatusCount({ customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => setTabs(data.data.data),
    onError,
  });

  const updateTaskListMutation = useMutation(updateTaskList, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["task-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const onSubmit = () => {
    console.log(data)
    updateTaskListMutation.mutate(data);
  };

  const columns = [
    {
      accessorKey: "customerCode",
      header: "CustomerCode",
    },
    {
      accessorKey: "warehouseCode",
      header: "WarehouseCode",
    },
    {
      accessorKey: "taskType",
      header: "Task Type",
      width: 120,
    },
    {
      accessorKey: "rfUserID",
      header: "RF User ID",
      width: 120,
    },
    {
      accessorKey: "refNo",
      header: "Ref No",
      width: 120,
    },
    {
      accessorKey: "lineNo",
      header: "Line No",
      width: 120,
    },
    {
      accessorKey: "status",
      header: "Status",
      width: 150,
      ...(status !== "COMPLETED" &&
        status !== "CANCEL" && { cell: (props) => EditableSelect({ ...props, options }) }),
    },
    {
      accessorKey: "reason",
      header: "Reason",
      width: 150,
      ...(status !== "COMPLETED" && status !== "CANCEL" && { cell: EditableText }),
    },
  ];

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}

      <MDBox my={3}>
        {alert}

        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />
      </MDBox>
      <TableCard>
        <CheckboxTable2 data={data} columns={columns} setData={setData} />
      </TableCard>

      {data.length > 0 && status !== "COMPLETED" && status !== "CANCEL" && (
        <InboundSubmitButton label="Submit" onClick={onSubmit} disabled={data.length === 0 || !editPermission} />
      )}
    </ListLayout>
  );
}

export default TaskList;
